module.exports = __webpack_public_path__ + "static/media/arrowNext.5c34dd65.svg";